<template>
  <b-breadcrumb class="breadCrumb">
    <b-breadcrumb-item>
      <b-icon icon="house-fill" scale="1.25" shift-v="1.25" aria-hidden="true"></b-icon>
      <router-link :to="{name: 'manager_dashboard'}"> ホーム</router-link>
    </b-breadcrumb-item>
    <b-breadcrumb-item ><router-link :to="{name: 'manager_employee'}"> 社員一覧</router-link></b-breadcrumb-item>
    <b-breadcrumb-item class="active">社員詳細</b-breadcrumb-item>
  </b-breadcrumb>
</template>

<script>
export default {
  name: 'Breadcrumb',
  data () {
    return {
      show: false
    }
  },
  props: {
    active: ''
  },
  computed: {

  }
}
</script>
<style scoped lang="scss">
  @import "@/assets/stylesheet/auth/breadcrumb.scss";
</style>



// WEBPACK FOOTER //
// src/components/share/Breadcrumb.vue